import { h } from "preact";
import { RoutableProps } from "preact-router";
import { useEffect, useState } from "preact/hooks";
import { resolvePath } from "../../api";
import { addProductToDatabase } from "../../api/product-api";
import { Alert } from "../../components/Alert";
import { Snackbar, SnackbarShowCommand } from "../../components/Snackbar";
import { TemplatePrint } from "../../components/TemplatePrint";
import { types } from "../../data/types";
import { useCommand } from "../../hooks";
import "./styles.scss";

export function GenerateSerialNumber(props: RoutableProps & { type?: string }) {
    const [serialNumber, setSerialNumber] = useState(sessionStorage.getItem(`last-serial-number-${props.type}`) ?? "");
    // const [serialNumber, setSerialNumber] = useState("ffaaddee");
    const refreshPrinter = useCommand();
    // const [printMode, setPrintMode] = useState(sessionStorage.getItem(`last-serial-number-print-mode-${props.type}`) ?? "single");
    const [printMode, setPrintMode] = useState("batch");
    const [batchCount, setBatchCount] = useState("1");
    const [eachCopyCount, setEachCopyCount] = useState("1");
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();

    useEffect(() => {
        sessionStorage.setItem(`last-serial-number-print-mode-${props.type}`, printMode);
    }, [printMode])

    useEffect(() => {
        refreshPrinter.run();
    }, [serialNumber]);

    useEffect(() => {
        return () => {
            sessionStorage.setItem(`last-serial-number-${props.type}`, "");
        };
    });

    useEffect(() => {
        if (Math.floor(+(batchCount)) * Math.floor(+(eachCopyCount)) > 100) {
            let newBatchCount = Math.floor(+batchCount);

            while(newBatchCount > 1 && newBatchCount * Math.floor(+(eachCopyCount)) > 100) {
                newBatchCount--;
            }

            setBatchCount(newBatchCount.toString());

            showSnackbarCommand.run("Maksymalna ilość naklejek jaką można wydrukować na raz to 100", "error", "error", 3000);
        }
    }, [batchCount]);


    useEffect(() => {
        if (Math.floor(+(batchCount)) * Math.floor(+(eachCopyCount)) > 100) {
            let newEachCopyCount = Math.floor(+eachCopyCount);

            while(newEachCopyCount > 1 && Math.floor((+batchCount)) * newEachCopyCount > 100) {
                newEachCopyCount--;
            }

            setEachCopyCount(newEachCopyCount.toString());

            showSnackbarCommand.run("Maksymalna ilość naklejek jaką można wydrukować na raz to 100", "error", "error", 3000);
        }
    }, [eachCopyCount]);

    if (!props.type) {
        return null;
    }

    const typeData = types[props.type];
    const fields: { [key: string]: any } = {};

    for (const prop in typeData.fields) {
        const fieldValue = typeData.fields[prop];

        if (fieldValue === "today") {
            fields[prop] = new Date();
        }
        else if (fieldValue === "serial-database") {
            fields[prop] = serialNumber;
        }
    }

    return <div class="generate-serial-number-page">
        <h1>{typeData.name}</h1>
        {/* <div class="stepper">
            <div class="steps">
                <div class="step done success" data-index="1">Wybierz sposób generowania naklejek</div>
            </div>
        </div>
        <div class="print-method">
            <div class={"primary" + (printMode === "single" ? " selected" : "")} onClick={() => setPrintMode("single")}>Pojedynczy</div>
            <div class={"primary" + (printMode === "batch" ? " selected" : "")} onClick={() => setPrintMode("batch")}>Masowy</div>
        </div> */}
        {printMode === "single" ? [
            <div class="stepper">
                <div class="steps">
                    <div class={"step" + (serialNumber ? " done success" : " current")} data-index="2">Wygeneruj numer seryjny</div>
                </div>
            </div>,
            <div class="create-serial">
                <button type="button" class="secondary" onClick={async () => {
                    const result = await addProductToDatabase(typeData.type);

                    console.log(result);

                    if (result.serialNumber) {
                        sessionStorage.setItem(`last-serial-number-${props.type}`, result.serialNumber);
                        setSerialNumber(result.serialNumber);
                    }
                }}>Wygeneruj nowy numer seryjny</button>
            </div>,
            serialNumber ? <div class="generated-serial paper">
                <div>
                    <h1>Wygenerowany numer seryjny</h1>
                    <div class="value">{serialNumber}</div>
                    <div class="serial-warn"><Alert type="warning" title="Uwaga!">Wygenerowany numer seryjny został już dodany do bazy danych. Należy go wydrukować i nakleić, gdyż inaczej nie zostanie on nigdy wykorzystany.</Alert></div>
                </div>
            </div> : null,
            serialNumber ? [
                <div class="stepper">
                    <div class="steps">
                        <div class="step current" data-index="3">Wydrukuj naklejkę</div>
                    </div>
                </div>,
                <div class="print paper">
                    <h1>Drukowanie naklejki</h1>
                    <TemplatePrint template={typeData.template} fields={fields} doRefresh={refreshPrinter} tapeImgBase={resolvePath("images/tapes/")}/>
                </div>
            ] : null
        ] : [
            <div class="stepper">
                <div class="steps">
                    <div class={"step" + (batchCount ? " done success" : " current")} data-index="1">Podaj ilość kodów seryjnych do wygenerowania</div>
                </div>
            </div>,
            <div class="create-serial">
                <input type="number" value={batchCount} onChange={(e) => setBatchCount(e.currentTarget.value)}/>
            </div>,
            <div class="stepper">
                <div class="steps">
                    <div class={"step" + (eachCopyCount ? " done success" : " current")} data-index="2">Podaj ilość kopii każdego kodu seryjnego (każda kopia będzie miała ten sam numer seryjny)</div>
                </div>
            </div>,
            <div class="create-serial">
                <input type="number" value={eachCopyCount} onChange={(e) => setEachCopyCount(e.currentTarget.value)}/>
            </div>,
            batchCount && eachCopyCount ? [
                <div class="stepper">
                    <div class="steps">
                        <div class="step current" data-index="3">Wydrukuj naklejki (łączna ilość: {parseInt(batchCount, 10) * parseInt(eachCopyCount, 10)})</div>
                    </div>
                </div>,
                <div class="print paper">
                    <h1>Drukowanie naklejek</h1>
                    <TemplatePrint template={typeData.template} fields={{ "field-serial": typeData.compatibility === "legacy" ? "000000" : "00000000", "field-date": new Date() }} copies={parseInt(batchCount, 10)} noAutoCut={true} doRefresh={refreshPrinter}
                        tapeImgBase={resolvePath("images/tapes/")} eachProvideFieldsCopy={parseInt(eachCopyCount, 10)} onProvideFields={async (index) => {
                            const fieldsData = {
                                fields: {}
                            } as {
                                fields: { [key: string]: any }
                                overrideFields?: { [key: string]: string }
                            };

                            for (const prop in typeData.fields) {
                                const fieldValue = typeData.fields[prop];

                                if (fieldValue === "today") {
                                    fieldsData.fields[prop] = new Date();
                                }
                                else if (fieldValue === "serial-database") {
                                    const result = await addProductToDatabase(typeData.type);

                                    if (!result.serialNumber) {
                                        throw new Error("Missing serial number");
                                    }

                                    fieldsData.fields[prop] = result.serialNumber;
                                }
                            }

                            return fieldsData;
                        }}/>
                </div>
            ] : null
        ]}
        <Snackbar doShow={showSnackbarCommand}/>
    </div>;
}
